import { render, staticRenderFns } from "./demand.vue?vue&type=template&id=212e0901&scoped=true&"
import script from "./demand.vue?vue&type=script&lang=js&"
export * from "./demand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e0901",
  null
  
)

export default component.exports